import { React, useState,useEffect} from 'react';

import { Form, Input } from 'antd';

import {GetProtuctRiskCalculatioanPlatformParams} from '../../Services/index';

export function ProductRiskCalculationPlatform({platformCalcProps }) {


    const [form] = Form.useForm();

    const [platformCalcRisk, setPlatformCalcRisk] = useState({ type: '3', scoreDividend: '', scoreDivisor: '' });

    const deleteErrorButton = (fieldKey) => {
        if (fieldKey) {
        }
    };

    const onFinishFailed = (errorInfo) => {
        if (!errorInfo) {
            form.resetFields();
        }
    };
    useEffect(() => {
        GetProtuctRiskCalculatioanPlatformParams()
            .then((result) => {
                form.setFieldsValue({
                    scoreDividend: result?.data?.data?.calcParams[0].scoreDividend || '',
                    scoreDivisor: result?.data?.data?.calcParams[0].scoreDivisor || '',
                })
                setPlatformCalcRisk({type:'3',scoreDividend:result?.data?.data?.calcParams[0].scoreDividend,scoreDivisor:result?.data?.data?.calcParams[0].scoreDivisor})
            })
    }, []);



    return (
        <>
            <Form
                form={form}
                name="basic"
                initialValues={{ remember: true }}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <div style={{ display: 'flex' }}>
                    <Form.Item
                        style={{ width: '50px' }}
                        label=""
                        name="scoreDividend"
                        rules={[
                            {
                                required: false,
                                message: 'Please input your scoreDividend!',
                            },
                        ]}
                        onFocus={() => deleteErrorButton('scoreDividend')}
                    >
                        <Input onChange={((event) => {
                      
                                const changedData = {
                                    ...platformCalcRisk,
                                    type: '3',
                                    scoreDividend: event.target.value,
                                }
                                setPlatformCalcRisk(changedData)
                                platformCalcProps(changedData)

                        })} />
                    </Form.Item> 
                    <b className="score__line">/</b>
                    <Form.Item
                        style={{ width: '50px' }}
                        name="scoreDivisor"
                        rules={[
                            {
                                required: false,
                                message: 'Please input your scoreDivisor!',
                            },
                        ]}
                        onFocus={() => deleteErrorButton('scoreDivisor')}
                    >
                        <Input onChange={((event) => {
                           
                                const changedData = {
                                    ...platformCalcRisk,
                                    type: '3',
                                    scoreDivisor: event.target.value,
                                }
                                setPlatformCalcRisk(changedData)
                                platformCalcProps(changedData)
                        })} />
                    </Form.Item>
                </div>
            </Form>
        </>
    )
}